import script from "./CategoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryView.vue?vue&type=script&setup=true&lang=js"

import "./CategoryView.vue?vue&type=style&index=0&id=5e1c46fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e1c46fd"]])

export default __exports__